import type { AdditionalFilterValues, ICandidate } from "@bbj-types/candidate";
import type { ISettingValue } from "@bbj-types/setting";
import { useSuspense } from "@root/api/tools/axios/axiosSuspenseWrapper";
import type { IDateRange, TAutocompleteAuthorsValue } from "@styleguide";
import { axiosCandidateInstance } from "./axios";
import type { TGetDashboardAdvancedFilter } from "./dashboard";

export interface IPostCandidatesSearch {
  data: Pick<ICandidate, "_id" | "profileId" | "firstName" | "lastName">[];
  total: number;
}

export type TAdditionalFilters = Record<string, AdditionalFilterValues | null | IDateRange>;

export interface IPostCandidatesSearchBody {
  search?: string;
  prescribers?: ISettingValue["value"][];
  authors?: TAutocompleteAuthorsValue["_id"][];
  coachingSteps?: ISettingValue["value"][];
  gender?: ICandidate["gender"][];
  status?: ISettingValue["value"][];
  actionPeriod?: IDateRange;
  actionTypes?: string[];
  additionalSections?: TAdditionalFilters;
  "address.isQPV"?: boolean;
  advancedFilters?: TGetDashboardAdvancedFilter[];
  "applicationFiles.jobs"?: string[];
  authorsActions?: string[];
  authorsSince?: Date;
  birthDate?: IDateRange;
  cafNumber?: string;
  cerStart?: IDateRange;
  cerEnd?: IDateRange;
  "coachingDates.startDate"?: IDateRange;
  coachingStep?: string[];
  driverLicenses?: string[];
  hideAutoGeneratedActions?: true;
  isAnonymized?: boolean;
  isArchived?: boolean;
  isDeleted?: boolean;
  multiSearch?: string;
  place?: string[];
  referentStructure?: string[];
  showActions?: "next" | "none" | "todo";
  source?: string[];
}

export const useSearchCandidatesSuspense = (filters?: IPostCandidatesSearchBody) => {
  return useSuspense(
    () =>
      axiosCandidateInstance.post<IPostCandidatesSearch>("/search", filters, {
        withCredentials: true,
      }),
    [filters]
  );
};
